<template>
  <div class="tinymce-box">
    <editor v-model="myValue" :init="init" @onClick="onClick" id="tinymce"></editor>
  </div>
</template>

<script>
import tinymce from 'tinymce/tinymce' //tinymce默认hidden，不引入不显示
import 'tinymce/icons/default/icons.min.js' //不引入所有的icon样式不出现
import Editor from '@tinymce/tinymce-vue'
import 'tinymce/themes/silver'
import 'tinymce/plugins/advlist'
import 'tinymce/plugins/anchor'
import 'tinymce/plugins/autolink'
import 'tinymce/plugins/autoresize'
import 'tinymce/plugins/autosave'
import 'tinymce/plugins/bbcode'
import 'tinymce/plugins/charmap'
import 'tinymce/plugins/code'
import 'tinymce/plugins/codesample'
import 'tinymce/plugins/colorpicker'
import 'tinymce/plugins/contextmenu'
import 'tinymce/plugins/directionality'
import 'tinymce/plugins/emoticons'
import 'tinymce/plugins/emoticons/js/emojis'
import 'tinymce/plugins/fullpage'
import 'tinymce/plugins/fullscreen'
import 'tinymce/plugins/help'
import 'tinymce/plugins/hr'
import 'tinymce/plugins/image'
import 'tinymce/plugins/imagetools'
import 'tinymce/plugins/importcss'
import 'tinymce/plugins/insertdatetime'
import 'tinymce/plugins/legacyoutput'
import 'tinymce/plugins/link'
import 'tinymce/plugins/lists'
import 'tinymce/plugins/media'
import 'tinymce/plugins/nonbreaking'
import 'tinymce/plugins/noneditable'
import 'tinymce/plugins/pagebreak'
import 'tinymce/plugins/paste'
import 'tinymce/plugins/preview'
import 'tinymce/plugins/print'
import 'tinymce/plugins/quickbars'
import 'tinymce/plugins/save'
import 'tinymce/plugins/searchreplace'
import 'tinymce/plugins/spellchecker'
import 'tinymce/plugins/tabfocus'
import 'tinymce/plugins/table'
import 'tinymce/plugins/template'
import 'tinymce/plugins/textpattern'
import 'tinymce/plugins/toc'
import 'tinymce/plugins/visualblocks'
import 'tinymce/plugins/visualchars'
import 'tinymce/plugins/wordcount'

import { prefix } from '@/api';
import { authToken } from '@/config';
import { storage } from '@/utils';
import axios from 'axios';
import { setTimeout } from 'timers';

export default {
  components: {
    Editor
  },
  name: 'tinymce-editor',
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String | Number,
      default: '请输入内容'
    },
  },
  data () {
    return {
      init: {
        language_url: '/tinymce/langs/zh_CN.js',
        language: 'zh_CN',
        skin_url: '/tinymce/skins/ui/oxide-dark', // 主题色
        content_style: `html, body{background: #424242; color: #fff;}`,
        height: 600,
        plugins: 'advlist autolink lists link image imagetools charmap print preview anchor link visualblocks code fullscreen print emoticons hr nonbreaking insertdatetime media table paste  quickbars searchreplace directionality pagebreak lineheight bdmap',
        toolbar: [
          'undo redo | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent |removeformat image| print link table | hr pagebreak insertdatetime  |fullscreen  emoticons  preview | bold italic formatselect fontselect fontsizeselect forecolor backcolor lineheight bdmap'
          // 'undo redo | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent |removeformat image| print help restoredraft link table |charmap hr pagebreak insertdatetime code |fullscreen wordcount emoticons nonbreaking searchreplace ltr rtl preview pagebreak',
          // 'formatselect anchor | bold italic fontselect fontsizeselect forecolor backcolor lineheight bdmap'
        ],
        placeholder: this.placeholder,
        fontsize_formats: '12px 14px 16px 18px 24px 36px 48px 56px 72px',
        elementpath: false,
        paste_data_images: true,
        color_map: this.colorMap,
        image_advtab: true,
        auto_focus: false,
        // quickbars_selection_toolbar: 'bold italic | link fontsizeselect blockquote forecolor backcolor',
        images_upload_handler: (blobInfo, success, failFun) => {
          let formData = new FormData()
          const file = blobInfo.blob();
          formData.append('file', file, file.name);
          axios.post(`${prefix}/admin/file/upload_image`, formData, { headers: { token: storage.getItem(authToken) } }).then(response => {
            const { code, result, message } = response;
            if (Object.is(code, 0)) {
              success(result.url);
            } else {
              this.$message.error(message);
            }
          }).catch(e => {
            this.$message.error(e);
          })
        }
      },
      myValue: this.value,
      colorMap: [
        '#BFEDD2', 'Light Green',
        '#FBEEB8', 'Light Yellow',
        '#F8CAC6', 'Light Red',
        '#ECCAFA', 'Light Purple',
        '#C2E0F4', 'Light Blue',

        '#2DC26B', 'Green',
        '#F1C40F', 'Yellow',
        '#E03E2D', 'Red',
        '#B96AD9', 'Purple',
        '#3598DB', 'Blue',

        '#169179', 'Dark Turquoise',
        '#E67E23', 'Orange',
        '#BA372A', 'Dark Red',
        '#843FA1', 'Dark Purple',
        '#236FA1', 'Dark Blue',

        '#ECF0F1', 'Light Gray',
        '#CED4D9', 'Medium Gray',
        '#95A5A6', 'Gray',
        '#7E8C8D', 'Dark Gray',
        '#34495E', 'Navy Blue',

        '#000000', 'Black',
        '#ffffff', 'White'
      ],
    }
  },
  mounted () {
    setTimeout(() => {
      tinymce.init({
        height: 1000
      })
    }, 100)
  },
  methods: {
    onClick (e) {
      this.$emit('onClick', e, tinymce)
    },
    // 可以添加一些自己的自定义事件，如清空内容
    clear () {
      this.myValue = ''
    }
  },
  watch: {
    value (newValue) {
      this.myValue = newValue
    },
    myValue (newValue) {
      this.$emit('input', newValue)
    }
  }
}

</script>
<style scoped>
::v-deep .tox-tinymce {
  border-radius: 5px;
}
::v-deep .tox-statusbar {
  display: none !important;
}
::v-deep .tox-dialog {
  width: 750px !important;
  min-height: 650px !important;
}
</style>